var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var DireccionMenu;
(function (DireccionMenu) {
    DireccionMenu[DireccionMenu["VERTICAL"] = 0] = "VERTICAL";
    DireccionMenu[DireccionMenu["HORIZONTAL"] = 1] = "HORIZONTAL";
})(DireccionMenu || (DireccionMenu = {}));
var Menu = /** @class */ (function () {
    function Menu(menu, orientacion, padre) {
        if (padre === void 0) { padre = null; }
        var _this = this;
        this.menu = menu;
        this.orientacion = orientacion;
        this.padre = padre;
        this.listeners = [];
        this.addListener = function (listener) { return _this.listeners = __spreadArray(__spreadArray([], _this.listeners, true), [listener], false); };
        this.removeListener = function (listener) { return _this.listeners = _this.listeners.filter(function (l) { return l !== listener; }); };
        this.inicializa = function (visible) {
            if (visible === void 0) { visible = false; }
            _this.configuraEnlaces();
            _this._visible = visible;
            var enlacesConSubmenu = _this.enlaces.filter(function (x) { return x.nextElementSibling; });
            enlacesConSubmenu.forEach(function (enlace) {
                var submenu = enlace.nextElementSibling;
                if (submenu) {
                    enlace.setAttribute('aria-expanded', 'false');
                    var orientacion = _this.orientacion === DireccionMenu.VERTICAL ? DireccionMenu.HORIZONTAL : DireccionMenu.VERTICAL;
                    (new Menu(submenu, orientacion, _this)).inicializa(false);
                }
            });
            _this.menu.setAttribute('aria-hidden', visible ? 'false' : 'true');
        };
        this.avanza = function (nodo) {
            var _a;
            var padre = nodo.parentNode;
            if (padre) {
                var siguiente = padre.nextElementSibling || ((_a = padre.parentNode) === null || _a === void 0 ? void 0 : _a.firstElementChild), enlace = siguiente === null || siguiente === void 0 ? void 0 : siguiente.querySelector('a');
                if (enlace) {
                    enlace.focus();
                    return true;
                }
            }
            return false;
        };
        this.retrocede = function (nodo) {
            var _a;
            var padre = nodo.parentNode;
            if (padre) {
                var siguiente = padre.previousElementSibling || ((_a = padre.parentNode) === null || _a === void 0 ? void 0 : _a.lastElementChild), enlace = siguiente === null || siguiente === void 0 ? void 0 : siguiente.querySelector('a');
                if (enlace) {
                    enlace.focus();
                    return true;
                }
            }
            return false;
        };
        this.primero = function () {
            _this.enlaces[0].focus();
            return true;
        };
        this.ultimo = function () {
            _this.enlaces[_this.enlaces.length - 1].focus();
            return true;
        };
        this.entraEnHijo = function (nodo) {
            var _a;
            var hijo = nodo.nextElementSibling;
            nodo.setAttribute('aria-expanded', 'true');
            if (hijo) {
                hijo.setAttribute('aria-hidden', 'false');
                (_a = hijo.querySelector('a')) === null || _a === void 0 ? void 0 : _a.focus();
                return true;
            }
            return false;
        };
        this.salDeHijo = function (nodo) {
            var padre = nodo.closest('ul'), enlace = padre === null || padre === void 0 ? void 0 : padre.previousElementSibling;
            if ((padre === null || padre === void 0 ? void 0 : padre.classList.contains('sub-menu')) && enlace instanceof HTMLAnchorElement) {
                padre.setAttribute('aria-hidden', 'true');
                enlace.setAttribute('aria-expanded', 'false');
                enlace.focus();
                return true;
            }
            return false;
        };
        this.cambiaVisibilidad = function () {
            _this._visible = !_this._visible;
            if (_this._visible) {
                _this.listeners.forEach(function (x) { return x.onAbrir(); });
                _this.menu.setAttribute('aria-hidden', 'false');
            }
            else {
                _this.listeners.forEach(function (x) { return x.onCerrar(); });
                _this.menu.setAttribute('aria-hidden', 'true');
            }
        };
        this.abre = function (primero) {
            if (primero === void 0) { primero = true; }
            _this._visible = true;
            _this.listeners.forEach(function (x) { return x.onAbrir(); });
            _this.menu.setAttribute('aria-hidden', 'false');
            if (primero) {
                _this.enlaces[0].focus();
            }
            else {
                _this.enlaces[_this.enlaces.length - 1].focus();
            }
        };
        this.cierra = function () {
            _this._visible = false;
            _this.listeners.forEach(function (x) { return x.onCerrar(); });
            _this.menu.setAttribute('aria-hidden', 'true');
        };
        this.buscaMenuPrincipal = function () { return _this.padre ? _this.padre.buscaMenuPrincipal() : _this; };
        this.abreOpcionSuperior = function (enlace) {
            _this.enlaces.forEach(function (x) {
                console.log(x.getAttribute('aria-expanded'));
                if (x === enlace && x.getAttribute('aria-expanded') === 'false') {
                    _this.abreOpcion(x);
                }
                else {
                    _this.cierraOpcion(x);
                }
            });
        };
        this.abreOpcion = function (enlace) {
            var menu = enlace.nextElementSibling;
            if (menu) {
                enlace.setAttribute('aria-expanded', 'true');
                menu.setAttribute('aria-hidden', 'false');
            }
        };
        this.cierraOpcion = function (enlace) {
            var menu = enlace.nextElementSibling;
            if (menu) {
                enlace.setAttribute('aria-expanded', 'false');
                menu.setAttribute('aria-hidden', 'true');
                [].slice.call(menu.querySelectorAll('ul'))
                    .forEach(function (submenu) {
                    console.log(submenu);
                    submenu.setAttribute('aria-hidden', 'true');
                });
            }
        };
        var enlaces = [].slice.call(menu.childNodes);
        this.enlaces = enlaces
            .filter(function (x) { return x.nodeName === 'LI'; })
            .map(function (x) { return x.firstElementChild; });
        this.enlaces.forEach(function (enlace, i) {
            enlace.setAttribute('tabindex', i === 0 && padre === null ? '0' : '-1');
        });
        menu.setAttribute('role', padre === null ? 'menubar' : 'menu');
        this.teclaAvanzar = orientacion === DireccionMenu.VERTICAL ? 'ArrowDown' : 'ArrowRight';
        this.teclaRetroceder = orientacion === DireccionMenu.VERTICAL ? 'ArrowUp' : 'ArrowLeft';
        this.teclaEntrarEnHijo = orientacion === DireccionMenu.VERTICAL ? 'ArrowRight' : 'ArrowDown';
        this.teclaSalirDeHijo = orientacion === DireccionMenu.VERTICAL ? 'ArrowLeft' : 'ArrowUp';
        this._visible = false;
    }
    Menu.prototype.configuraEnlaces = function () {
        var _this = this;
        this.enlaces.forEach(function (enlace) {
            var href = enlace.getAttribute('href');
            if (href && href[0] === '#') {
                enlace.addEventListener('click', function (e) {
                    var padre = _this.buscaMenuPrincipal();
                    padre.abreOpcionSuperior(enlace);
                    e.preventDefault();
                });
                enlace.setAttribute('aria-has-popup', 'true');
            }
            enlace.addEventListener('keydown', function (e) {
                var preventDefault = false;
                if (e.key === _this.teclaAvanzar) {
                    preventDefault = _this.avanza(enlace);
                }
                else if (e.key === _this.teclaRetroceder) {
                    preventDefault = _this.retrocede(enlace);
                }
                else if (e.key === _this.teclaEntrarEnHijo) {
                    preventDefault = _this.entraEnHijo(enlace);
                }
                else if (e.key === _this.teclaSalirDeHijo || e.key === 'Escape') {
                    preventDefault = _this.salDeHijo(enlace);
                }
                else if (e.key === 'Home') {
                    preventDefault = _this.primero();
                }
                else if (e.key === 'End') {
                    preventDefault = _this.ultimo();
                }
                else if (e.key.length === 1) {
                    var enlaces = _this.enlaces
                        .filter(function (x) { var _a; return x !== enlace && ((_a = x.textContent) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase()[0]) === e.key.toLowerCase(); });
                    if (enlaces.length) {
                        enlaces[0].focus();
                        preventDefault = true;
                    }
                }
                if (preventDefault) {
                    e.preventDefault();
                }
            });
        });
    };
    Object.defineProperty(Menu.prototype, "visible", {
        get: function () {
            return this._visible;
        },
        enumerable: false,
        configurable: true
    });
    return Menu;
}());
export { Menu };
